
  import axios, { AxiosError } from 'axios';
  import { IUserData } from "@/store/UsersStore";
  import { defineComponent, ref, onMounted, onBeforeMount, watch, handleError } from 'vue';
  import { useRouter } from "vue-router";
  import { campHandleCPF } from '@/composables/DataValidation';
  import { useUsersStore } from "@/store/UsersStore";
  import useAlert from "@/composables/Alert";
  import {
    CampHeader,
    CampEmptyListFeedbackV2,
    CampTable,
    CampTableTd,
    CampTableTh,
    CampFooterPaginationControl,
    CampBtnGenerateExcel
  } from '@/components';
  import { useLoaderStore } from "@/store/LoaderStore";
  import { useStoreStore } from '@/store/StoreStore';
  import CampModalDelRegister from '@/components/CampModalDelRegister.vue';
  import CampModalRecoverRegister from '@/components/CampModalRecoverRegister.vue';
  import { campGoToTopByScrollMode } from '@/composables/Helpers';
  import ModalErroInfo from '@/views/Developer/components/ModalErroInfo.vue';
  import { useCompanyStore } from '@/store/CompanyStore';
  import { useFilterMainStore } from '@/store/FilterMainStore';
  import { ICompanyData } from '@/store/CompaniesStore';
  
  export interface ICompetitorData {
    id: number;
    name: string;
    cpf: string;
    email: string;
    tel: string;
    url_media?: string | null;
    role?: number;
    deleted_at: string | null;
    cpf_competitor: string;
    AccessCode: number
    last_page: number
    id_company: number
    latestAccessCode: number | null
    store: number
    latestAccess: string| null
    use_version: string | null
    card_number: string | null
    card_pin: string | null
    id_role: number
    storeName: string | null
    companyName: string | null
    created_at: string
    financial_data: string
    updated_at: string | null 
    url_photo: string | null
    birth_date: string | null

  }

  interface IPagination {
    currentPage: number;
    totalPages: number;
    perPage: number;
    totalItems: number;
  }
  
  export default defineComponent({
    name: "CompetitorListErro",
    components: {
      CampHeader,
      CampEmptyListFeedbackV2,
      CampTable,
      CampTableTd,
      CampTableTh,
      CampModalDelRegister,
      CampModalRecoverRegister,
      CampFooterPaginationControl,
      ModalErroInfo,
      CampBtnGenerateExcel
    },
    setup() {
      const storeStore = useStoreStore()
      const router = useRouter();
      const relationProps = ref(false)
      const companyStore = useCompanyStore()
      const filterMainStore = useFilterMainStore()
      const ModalErroInfo = ref<{ competitorErros: any[] | null, toggle: boolean }>({
        competitorErros: null,
        toggle: true
      })
      const pageID = ref(1)
      const pageTotal = ref(1)
      const queryObject = ref<{
        isLoading: boolean,
        noError: boolean,
        data:  null | ICompetitorData[]
        pagination?: IPagination
      }>({
        isLoading: false,
        noError: false,
        data: null
      })
      const printCompetitors = ref<ICompetitorData[]>([]);
      const errosLogs = ref<any[]>([]);
      const keywordSearch = ref("")
      const relationData = ref<ICompetitorData | null>(null)
      const loaderStore = useLoaderStore();
      const isLoading = ref(false)
      const usersStore = useUsersStore()
      const { showTimeAlert } = useAlert()
      const showModal = ref(false);
      const storeList = ref<any[]>([])
      const selectedCompanies = ref<string[]>([])
      const selectedStores = ref<string[]>([])

      const loadCompaniesAndStores = async () => {
        try {
          isLoading.value = true;
          const [storesResponse] = await Promise.all([
            axios.get('/api/getAllStores')
          ]);
          storeList.value = storesResponse.data.data
        } catch (error) {
          if (error instanceof AxiosError) {
            showTimeAlert(error.response?.data.message, "error")
          } else {
            showTimeAlert("Algo deu errado!", "error")
          }
        } finally {
          isLoading.value = false;
        }
      }

      const fetchCompetitors = async () => {
        try {
          isLoading.value = true;

          const storeId = Array.isArray(selectedStores.value) ? selectedStores.value.map(Number) : []
          const companyId = Array.isArray(selectedCompanies.value) ? selectedCompanies.value.map(Number) : []

          const response = await axios.get('/api/getCompetitorsLogErros', {
            params: {
              page: pageID.value,
              idCompany: companyId,
              idStore: storeId,
            }
          });
        //   pageTotal.value = response.data.data.competitor.last_page
          printCompetitors.value = response.data.data.competitor
          errosLogs.value = response.data.data.errosLog
        //   usersStore.setCompanies(printCompetitors.value)
          queryObject.value.data = response.data.data.competitor
          filterCompetitors()
        } catch (error) {
          if (error instanceof AxiosError) {
            showTimeAlert(error.response?.data.message, "error")
          } else {
            showTimeAlert("Algo deu errado!", "error")
          }
        } finally {
          loaderStore.close()
          isLoading.value = false
        }
      }

      const filterCompetitors = () => {
        const keyword = keywordSearch.value.toLowerCase()
      }

  
      // Functions
      function funcDetailRelationData(data) {
        relationProps.value = !relationProps.value
        relationData.value = data
      }
  
      function handleFilterObjectsByKeyword(): boolean {
        if(!queryObject.value.data)
          return true
        printCompetitors.value = queryObject.value.data.filter((item) => {
          for (const key in item) {
            if (key !== 'checked') {
              const propValue = item[key];
              if (typeof propValue === 'string' && propValue.toLowerCase().includes(keywordSearch.value.toLowerCase())) {
                return true;
              }
              if (typeof propValue === 'number' && keywordSearch!.toString() === propValue.toString()) {
                return true;
              }
            }
          }
          return false;
        });
        return false
      }
  
      function handleDataLocalStorage() {
        const ss = JSON.parse(localStorage.getItem("ss")!)
        if(ss) {
          storeStore.setId(ss.i)
          storeStore.setFantasyName(ss.n)
        }
      }

      const ModalErroInfoLog = (el: ICompetitorData) => {
        ModalErroInfo.value.toggle = !ModalErroInfo.value.toggle
        errosLogs.value.filter(e => {
            if(e.id_competitor == el.id) {
                return e
            }
        })
        errosLogs.value = errosLogs.value.sort((a, b) => {
                const dateA = a.created_at ? new Date(a.created_at).getTime() : 0;
                const dateB = b.created_at ? new Date(b.created_at).getTime() : 0;
                return dateB - dateA;
        });        
        ModalErroInfo.value.competitorErros = errosLogs.value.filter(e => e.id_competitor === el.id)
      }

      function handleInitFilterModal() {
        if(!companyStore.getId) {
          filterMainStore.hideModal()
          filterMainStore.showModal()
        }
      }

      async function handlePaginationRendering(ID: number) {
        loaderStore.open()
        pageID.value = ID
        await fetchCompetitors()
        campGoToTopByScrollMode(false)
      }

  
      // Life Cycles
      onBeforeMount(() => handleDataLocalStorage())
  
      onMounted( async () =>(handleInitFilterModal(), loadCompaniesAndStores(), filterCompetitors(),fetchCompetitors()
      ))

      watch(() => companyStore.id, () => fetchCompetitors(), {deep: true})

      watch(() => { companyStore.company, storeStore.store }, () => fetchCompetitors(), { deep: true })

      watch(() => storeStore.getId, () =>isLoading.value = true)
  
      watch(() => storeStore.store, () => fetchCompetitors())
  
      watch(() => keywordSearch.value, () => handleFilterObjectsByKeyword())

      watch(() => { companyStore.getId, storeStore.getId }, () => isLoading.value = true, {deep: true})

      watch([selectedCompanies, selectedStores], filterCompetitors)


      return {
        router,
        isLoading,
        printCompetitors,
        queryObject,
        keywordSearch,
        campHandleCPF,
        relationData,
        funcDetailRelationData,
        relationProps,
        ModalErroInfo,
        ModalErroInfoLog,
        handlePaginationRendering,
        pageID,
        pageTotal,
        showModal,
        selectedCompanies,
        selectedStores,
        filterCompetitors,
        storeList,
        fetchCompetitors,
      }
    }
  })
  